import BodyTemperatureRecipes from './BodyTemperatureRecipe.js';
import BlobRecipes from './BlobRecipes.js';
import MatchingRecipes from './MatchingRecipes.js';
import WbcRecipes from './WbcDiffRecipes.js';
import ECGRecipes from './ECGRecipes.js';
import BloodGlucoseRecipes from './BloodGlucoseRecipes.js';
import PersistentFileSystemRecipes from './PersistentFileSystemRecipes.js';
import AudioExerciseRecipes from './AudioExerciseRecipes.js';
import LeuteRecipes from './Leute/recipes.js';
import Certificates from './Certificates/CertificateRecipes.js';
import SignatureRecipes from './SignatureRecipes.js';
import ChatRecipes from './ChatRecipes.js';
import ConsentRecipes_1_1_0 from './ConsentRecipes/ConsentRecipes_1_1_0.js';
import IoMRequestRecipes from './IoM/IoMRequest.js';
import IoMRequestsRegistryRecipes from './IoM/IoMRequestsRegistry.js';
import CanRiskRecipes from './CanRiskRecipes/CanRiskResultRecipes.js';
import ContactRelationshipRecipe from './ContactRelationship/ContactRelationship-1-0-0.js';
import ContactMilestoneRecipe from './ContactMilestone/ContactMilestone-1-0-0.js';
import CommunicationEventRecipe from './CommunicationEvent/CommunicationEvent-1-0-0.js';
const RecipesExperimental = [
    ...BodyTemperatureRecipes,
    ...BlobRecipes,
    ...MatchingRecipes,
    ...WbcRecipes,
    ...ECGRecipes,
    ...BloodGlucoseRecipes,
    ...PersistentFileSystemRecipes,
    ...AudioExerciseRecipes,
    ...Certificates,
    ...ChatRecipes,
    ...LeuteRecipes,
    ...SignatureRecipes,
    ...ConsentRecipes_1_1_0,
    ...IoMRequestRecipes,
    ...IoMRequestsRegistryRecipes,
    ...CanRiskRecipes,
    ContactRelationshipRecipe,
    ContactMilestoneRecipe,
    CommunicationEventRecipe
];
export default RecipesExperimental;
//# sourceMappingURL=recipes-experimental.js.map